import PropertiesDetail from "./PropertiesDetailContainer";

export default PropertiesDetail;
